import { DecisionTypes } from "../enums/decision-types";

export class OptimizePlanSignalRMessage {
    decisionType!: DecisionTypes;
    id!: string;
    subject!: string;
}